export default {
  namespaced: true,

  state: {
    mainName: null,
    subName: null,
    accessToken: null,
    client: null,
    uid: null,
    role: null,
    lastOperatedDate: null,
    userId: null,
    schoolData: null,
    isDemo: null,
    remainingDownloadCount: null,
    accountType: 'free',
    isShingaku: false,
  },

  getters: {
    isAdmin: state => {
      return state.role === 'Admin'
    },
    isTeacher: state => {
      return state.role === 'Teacher'
    },
    isDemo: state => {
      return state.isDemo
    },
    isPaid: state => {
      return state.accountType === 'paid'
    },
    isFree: state => {
      return state.accountType === 'free'
    },
    homePath: state => {
      // /admin/home or /teacher/home
      return '/'+state.role.toLowerCase()+'/home'
    },
    isShingaku: state => {
      return state.isShingaku
    },
  },

  mutations: {
    setRole(state, payload) {
      state.role = payload.role;
    },

    setMainName(state, payload) {
      state.mainName = payload.mainName;
    },

    setSubName(state, payload) {
      state.subName = payload.subName;
    },

    setLastOperatedDate(state, payload) {
      state.lastOperatedDate = payload.lastOperatedDate;
    },

    setUserId(state, payload) {
      state.userId = payload.userId;
    },

    setSchoolData(state, payload) {
      state.schoolData = payload.schoolData;
    },

    setIsDemo(state, payload) {
      state.isDemo = payload.isDemo;
    },

    setRemainingDownloadCount(state, payload) {
      state.remainingDownloadCount = payload.remainingDownloadCount;
    },

    setAccountType(state, payload) {
      state.accountType = payload.accountType;
    },

    setIsShingaku(state, payload) {
      state.isShingaku = payload.isShingaku;
    },

    login(state, payload) {
      state.accessToken = payload.accessToken;
      state.client = payload.client;
      state.uid = payload.uid;
      state.userId = payload.userId;
      state.schoolData = payload.schoolData;
    },

    logout(state) {
      state.accessToken = null
      state.client = null
      state.uid = null
      state.userId = null;
      state.schoolData = null;
      state.isDemo = null
      state.remainingDownloadCount = null
      state.accountType = 'free'
      state.isShingaku = false
    },
  },
}
